var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ods-goal__container"},_vm._l((_vm.sdgs),function(ref){
var id = ref.id;
var ref_attributes = ref.attributes; if ( ref_attributes === void 0 ) ref_attributes = {};
var slug = ref_attributes.slug;
return _c('div',{key:id,staticClass:"ods-goal__content"},[_c('a',{class:("ods-goal2 ods-goal2__" + (slug.padStart(2, 0)) + "__" + _vm.locale),attrs:{"href":(_vm.baseUrl + "/ods2/" + (+slug))}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }